export function initHotjar() {
  if (!document.getElementById('HotjarScript')) {
    (function (h, o, t, j, a, r) {
      h.hj
        = h.hj
        || function () {
          // eslint-disable-next-line prefer-rest-params
          (h.hj.q = h.hj.q || []).push(arguments)
        }
      h._hjSettings = { hjid: 2811170, hjsv: 6 }
      a = o.getElementsByTagName('head')[0]
      r = o.createElement('script')
      r.id = 'HotjarScript'
      r.async = 1
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv
      a.appendChild(r)
    })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=')
  }
}
